<template>
  <div>
    <slot name="default" v-if="true || $auth.authenticated"></slot>
    <div style="padding: 30px 0;" v-else>
       <h3 style="text-align: center;" v-if="content">Please login to access this content:</h3>
       <h3 style="text-align: center;" v-else>Please login to access this page:</h3>
       <br>
       <login-signup @refresh="refresh"></login-signup>
    </div>
  </div>
</template>

<script>
import LoginSignup from '@/components/LoginSignup'

const components = {
  LoginSignup
}

const props = {
  content: {
    type: Boolean,
    required: false
  }
}

const name = 'login_wrapper'

const methods = {
  refresh () {
    this.$forceUpdate()
  }
}

export default {
  props,
  name,
  methods,
  components
}
</script>
